<template>
  <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 8C15.3871 6.77427 14.1343 6 12.7639 6H12M8 16C8.61287 17.2257 9.86566 18 11.2361 18H12M12 18H13.0599C14.2316 18 15.2854 17.2866 15.7205 16.1986C16.386 14.5351 15.3787 12.6757 13.6219 12.3244L10.3781 11.6756C8.62125 11.3242 7.61404 9.4649 8.27945 7.80137C8.71464 6.7134 9.76836 6 10.9401 6H12M12 18V20M12 6V4"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
